// extracted by mini-css-extract-plugin
export default {"title":"_659ac851d4","bld":"_123e74c59b"};